import {Injectable} from '@angular/core';
import {WebViewerOptions} from '@pdftron/webviewer';
import {BehaviorSubject, firstValueFrom} from 'rxjs';
import {API} from '../../shared/constants/api.constants';
import {ErrorHandlingHttpClient} from '../../shared/services/error-handling-http-client.service';
import {map} from 'rxjs/operators';



@Injectable({ providedIn: 'root' })
export class PdftronKeyService {
  private licenseKeySubject = new BehaviorSubject<string | null>(null);
  licenseKey$ = this.licenseKeySubject.asObservable();
  private licenseKey = '';
  constructor(private errorHandlingHttpClient: ErrorHandlingHttpClient) {}

  async loadPdfLicense(): Promise<string> {
    if (!this.licenseKeySubject.value) {
      const key = await firstValueFrom(
        this.errorHandlingHttpClient.get(API.getPDFTronKey()).pipe(map(data => data.key))
      );
      const decoded = atob(key);
      this.licenseKey = decoded;
      this.licenseKeySubject.next(decoded);
    }
    return this.licenseKeySubject.value!;
  }

  getLicenseKey(): string {
    return this.licenseKey;
  }
}

// Default WebViewer configuration
export function createPdfConfig(licenseKey: string): WebViewerOptions {
  return {
    path: '../webviewer',
    fullAPI: true,
    licenseKey,
    enableAzureWorkaround: true,
    enableAnnotations: false,
    disabledElements: [
      'toolbarGroup-Edit',
      'toolbarGroup-Annotate',
      'toolbarGroup-Shapes',
      'toolbarGroup-Insert',
      'toggleNotesButton'
    ]
  };
}
